import { IconButton } from '@/components/IconButton'
import {
  EditorListBadge,
  EditorListItemActions,
  EditorListItemContent,
  EditorListItemDescription,
  EditorListItemTitle,
  SortableEditorListItem,
} from '@/features/legends/components/EditorList'
import styles from './RoutingPlanRow.module.css'

const planGroup = Symbol('routing-plan')

export interface RoutingPlanRowProps {
  index: number
  label: string
  description: string
  /**
   * Minutes.
   */
  duration: number
  isSelected?: boolean
  hasError?: boolean
  isDisabled?: boolean
  onPress: () => unknown
  onRemove: () => unknown
  onMove: (fromIndex: number, toIndex: number) => unknown
  testId?: string
}

/**
 * A routing plan in the list of plans, dragged to change the order they run
 * in.
 */
export function RoutingPlanRow({
  index,
  label,
  description,
  duration,
  isSelected,
  hasError,
  isDisabled,
  onPress,
  onRemove,
  onMove,
  testId,
}: RoutingPlanRowProps) {
  return (
    <SortableEditorListItem
      group={planGroup}
      index={index}
      onMove={onMove}
      isDisabled={isDisabled}
      isSelected={isSelected}
      hasError={hasError}
      onPress={onPress}
      testId={testId}
    >
      <div className={styles.root}>
        <span className={styles.index}>{index + 1}</span>
        <EditorListItemContent>
          <EditorListItemTitle isMuted={!label}>
            {label || 'No plan label.'}
          </EditorListItemTitle>
          <EditorListItemDescription isMuted={!description}>
            {description || 'No description.'}
          </EditorListItemDescription>
        </EditorListItemContent>
        <EditorListItemActions>
          <EditorListBadge>
            {duration === 1 ? '1 minute' : `${duration} minutes`}
          </EditorListBadge>
          {!isDisabled && (
            <IconButton
              name="close"
              label="Remove plan"
              size={14}
              onPress={onRemove}
              testId={testId && `${testId}-remove-button`}
            />
          )}
        </EditorListItemActions>
      </div>
    </SortableEditorListItem>
  )
}
